// extracted by mini-css-extract-plugin
var _1 = "DuVb8";
export { _1 as "base" }
